

let Line =  {
        drawTime: 'afterDraw', // overrides annotation.drawTime if set
        id: 'a-line-1', // optional
        type: 'line',
        mode: 'horizontal',
        scaleID: 'y-axis-0',
        value: '25',
        borderColor: 'red',
        borderWidth: 2,
    };

export default Line;


// WEBPACK FOOTER //
// ./src/components/chart/objects/Line.js